import React from "react";

import Highcharts from "highcharts";
import HighchartsReact, { HighchartsReactRefObject } from "highcharts-react-official";
import exportData from "highcharts/modules/export-data";
import exporting from "highcharts/modules/exporting";
import fullscreen from "highcharts/modules/full-screen";

exporting(Highcharts);
exportData(Highcharts);
fullscreen(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ",", //separator for thousand numbers in tooltips
    numericSymbols: ["k", "M", "B", "T"]
  }
});

export const MemoizedHighchart = React.memo(
  ({
    options,
    className,
    style,
    chartRef
  }: {
    options: any;
    className?: string;
    style?: React.CSSProperties;
    chartRef?: React.Ref<HighchartsReactRefObject>;
  }) => {
    return (
      <HighchartsReact containerProps={{ className, style }} highcharts={Highcharts} options={options} ref={chartRef} />
    );
  }
);
